/**
 * トップページKVエリア
 */
import ResizeWatch from '../utils/ResizeWatch';

export default class homeKV {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'homeKV';
    this.elID = 'js-home-kv';
    this.preventWidth = 0;

    this.init();
  }

  /**
   * 表示前
   */
  init() {
    this.resizeUpdate();
    ResizeWatch.registerObserver(this.name, this);
  }

  /**
   * 表示時
   */
  start() {

  }

  /**
   * ウィンドウリサイズ
   */
  resizeUpdate() {
    let isChange = Useragnt.pc || (!Useragnt.pc && this.preventWidth != window.innerWidth);
    if (isChange) {
      document.getElementById(this.elID).style.height = window.innerHeight + 'px';
    }
    this.preventWidth = window.innerWidth;
  }
}
